import React, { FC } from 'react';
import { GRID_GAP } from '../utils/tileGenerator';
import { getGapConnectors, getGridPixelSize, connectorColor } from '../utils/tileLayout';

type EdgeConnectorOverlayProps = {
  tiles: string[];
  columns: number;
  tileSize: number;
  show: boolean;
  zIndex?: number;
  gap?: number;
  connectorThickness?: number;
};

const EdgeConnectorOverlay: FC<EdgeConnectorOverlayProps> = ({
  tiles,
  columns,
  tileSize,
  show,
  zIndex = 0,
  gap = GRID_GAP,
  connectorThickness,
}) => {
  if (!show || tiles.length === 0) return null;

  const connectors = getGapConnectors(tiles, columns, tileSize, gap, connectorThickness);
  const { width, height } = getGridPixelSize(tiles.length, columns, tileSize, gap);

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width,
        height,
        pointerEvents: 'none',
        zIndex,
      }}
    >
      {connectors.map((connector) => (
        <div
          key={connector.id}
          style={{
            position: 'absolute',
            left: connector.left,
            top: connector.top,
            width: connector.width,
            height: connector.height,
            backgroundColor: connectorColor(connector.matched),
          }}
        />
      ))}
    </div>
  );
};

export default EdgeConnectorOverlay;
